module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp23_5.0140ec4f.png";